import { useEffect, useState } from "react";
import { hashAccountId } from "utils/accountHint";

// userId 의 단방향 해시(OneLink deep_link_sub2 용)를 비동기 계산해 반환한다.
// 계산 전/실패/userId 없음이면 undefined (호출부는 해시 없이 동작).
export default function useAccountIdHash(userId?: number) {
  const [hash, setHash] = useState<string | undefined>();

  useEffect(() => {
    let alive = true;
    if (userId == null) {
      setHash(undefined);
      return;
    }
    hashAccountId(userId).then((h) => {
      if (alive) setHash(h);
    });
    return () => {
      alive = false;
    };
  }, [userId]);

  return hash;
}
